import { useEffect, useState } from 'react';
import { resolveData } from '@/features/populate/lib/helpers';
import { DropZone } from '@measured/puck';
import React from 'react';
import ReactDOM from 'react-dom';

(window as any).React = React;
(window as any).ReactDOM = ReactDOM;

interface ExternalConfig {
  editor: any;
  uiSchema: any;
}

export function useExternalConfig() {
  const [config, setConfig] = useState<ExternalConfig | null>(null);

  useEffect(() => {
    const scriptUrl = import.meta.env.VITE_COMPONENTS_URL;

    let cancelled = false;

    const loadFromGlobal = () => {
      if (cancelled) return;

      const lib = (window as any).LibelleComponents;

      if (!lib) {
        console.error('LibelleComponents global is not available on window');
        return;
      }

      const dropzoneFn = (props: any) => <DropZone {...props} />;

      setConfig({
        editor: lib.config(resolveData, dropzoneFn),
        uiSchema: lib.uiSchema,
      });
    };

    const existingScript = document.querySelector(
      `script[src="${scriptUrl}"]`
    ) as HTMLScriptElement | null;

    if (existingScript) {
      if ((window as any).LibelleComponents) {
        loadFromGlobal();
      } else {
        existingScript.addEventListener('load', loadFromGlobal, { once: true });
      }
      return;
    }

    const script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    script.addEventListener('load', loadFromGlobal, { once: true });
    script.addEventListener('error', () => {
      if (!cancelled) {
        console.error(`Failed to load external script: ${scriptUrl}`);
      }
    });

    document.body.appendChild(script);

    return () => {
      cancelled = true;
    };
  }, []);

  return config;
}
